import {observer} from 'mobx-react';
import {Column, Row} from '@vidazoo/ui-kit';
import React from 'react';
import {ChartEditModel} from '../../../../modules/charts/item/edit/model/ChartEditModel.mdl';
import {ChartCreateModel} from '../../../../modules/charts/item/create/model/ChartCreateModel.mdl';

export interface IDiffTableChartRowProps {
    appearance?: 'default' | 'classic';
    itemIndex: number;
    viewportIndex: number;
    style: React.CSSProperties;
    model: ChartEditModel | ChartCreateModel;
}

function DiffTableChartRow({itemIndex, style, model, appearance}: IDiffTableChartRowProps): React.JSX.Element {
    const item = model.maskItems.at(itemIndex);

    const classic = appearance === 'classic';
    const rowBackground = itemIndex % 2
        ? 'var(--dashboard-table-row-odd-background)'
        : 'var(--dashboard-table-row-background)';
    const rowStyle = classic ? {...style,
        '--table-viewport-background-color': rowBackground,
        '--table-data-column-background-color': rowBackground,
        '--table-column-sticky-background-color': rowBackground,
    } as React.CSSProperties : style;
    const cellStyle = cell => {
        if (!classic || cell.rowType !== 'field' || !cell.name?.includes('(D)')) return undefined;
        const custom = model.item.data.customStyles?.find(rule => `${rule.metric}_d` === cell.type);
        const threshold = custom?.threshold ?? 30;
        const backgroundColor = cell.value < -threshold ? custom?.lowColor || '#FB0201'
            : cell.value > threshold ? custom?.highColor || '#1D8000' : undefined;
        return backgroundColor ? {backgroundColor, color: '#fff', fontWeight: 900} : undefined;
    };
    const displayValue = cell => {
        if (cell.displayValue !== undefined && cell.displayValue !== null) return cell.displayValue;
        if (typeof cell.value !== 'number') return cell.value;
        if (cell.name?.includes('(D)')) return `${Math.round(cell.value)}%`;
        return cell.value.toLocaleString(undefined, {maximumFractionDigits: 0});
    };
    return (
        <Row style={rowStyle} key={itemIndex} index={itemIndex}>
            {(item as any).map((row) => (
                <Column key={row.type || row.name} colKey={row.type || row.name} style={cellStyle(row)}>
                    {classic && row.rowType === 'group' && row.link
                        ? <a href={row.link} target="_blank" rel="noreferrer">{row.value}</a>
                        : classic ? displayValue(row) : row.value}
                </Column>
            ))}
        </Row>
    )
}

export default observer(DiffTableChartRow);
